module.exports = __webpack_public_path__ + "static/media/nav_menu.37861edd.svg";